import { render } from "./AddImages.vue?vue&type=template&id=761467ab&scoped=true"
import script from "./AddImages.vue?vue&type=script&lang=js"
export * from "./AddImages.vue?vue&type=script&lang=js"

import "./AddImages.vue?vue&type=style&index=0&id=761467ab&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761467ab"]])

export default __exports__